import BigNumber from 'bignumber.js'
import { ethers } from 'ethers'
import { httpProvider } from 'hooks/useWeb3'
import Web3 from 'web3'
import pancakeLpABI from 'config/abi/pancake_lp.json'
import bep20 from 'config/abi/erc20.json'
import { AbiItem } from 'web3-utils'

export const approve = async (lpContract, masterChefContract, account) => {
  return lpContract.methods
    .approve(masterChefContract.options.address, ethers.constants.MaxUint256)
    .send({ from: account })
}

export const stake = async (masterChefContract, pid, amount, account) => {
  return masterChefContract.methods
    .deposit(pid, new BigNumber(amount).times(new BigNumber(10).pow(18)).toString())
    .send({ from: account })
    .on('transactionHash', (tx) => {
      return tx.transactionHash
    })
}

export const sousStake = async (sousChefContract, amount, account) => {
  return sousChefContract.methods
    .deposit(new BigNumber(amount).times(new BigNumber(10).pow(18)).toString())
    .send({ from: account })
    .on('transactionHash', (tx) => {
      return tx.transactionHash
    })
}

export const sousStakeBnb = async (sousChefContract, amount, account) => {
  return sousChefContract.methods
    .deposit()
    .send({ from: account, value: new BigNumber(amount).times(new BigNumber(10).pow(18)).toString() })
    .on('transactionHash', (tx) => {
      return tx.transactionHash
    })
}

export const unstake = async (masterChefContract, pid, amount, account) => {
  return masterChefContract.methods
    .withdraw(pid, new BigNumber(amount).times(new BigNumber(10).pow(18)).toString())
    .send({ from: account })
    .on('transactionHash', (tx) => {
      return tx.transactionHash
    })
}

export const claimLocked = async (lockerContract, account) => {
  return lockerContract.methods
    .claim()
    .send({ from: account })
    .on('transactionHash', (tx) => {
      return tx.transactionHash
    })
}

export const sousUnstake = async (sousChefContract, amount, account) => {
  // shit code: hard fix for old CTK and BLK
  if (sousChefContract.options.address === '0x3B9B74f48E89Ebd8b45a53444327013a2308A9BC') {
    return sousChefContract.methods
      .emergencyWithdraw()
      .send({ from: account })
      .on('transactionHash', (tx) => {
        return tx.transactionHash
      })
  }
  if (sousChefContract.options.address === '0xBb2B66a2c7C2fFFB06EA60BeaD69741b3f5BF831') {
    return sousChefContract.methods
      .emergencyWithdraw()
      .send({ from: account })
      .on('transactionHash', (tx) => {
        return tx.transactionHash
      })
  }
  return sousChefContract.methods
    .withdraw(new BigNumber(amount).times(new BigNumber(10).pow(18)).toString())
    .send({ from: account })
    .on('transactionHash', (tx) => {
      return tx.transactionHash
    })
}

export const sousEmegencyUnstake = async (sousChefContract, amount, account) => {
  return sousChefContract.methods
    .emergencyWithdraw()
    .send({ from: account })
    .on('transactionHash', (tx) => {
      return tx.transactionHash
    })
}

export const harvest = async (masterChefContract, pid, account) => {
  return masterChefContract.methods
    .harvest(pid)
    .send({ from: account })
    .on('transactionHash', (tx) => {
      return tx.transactionHash
    })
}

export const soushHarvest = async (sousChefContract, account) => {
  return sousChefContract.methods
    .deposit('0')
    .send({ from: account })
    .on('transactionHash', (tx) => {
      return tx.transactionHash
    })
}

export const soushHarvestBnb = async (sousChefContract, account) => {
  return sousChefContract.methods
    .deposit()
    .send({ from: account, value: new BigNumber(0) })
    .on('transactionHash', (tx) => {
      return tx.transactionHash
    })
}

export const getPriceByLP = async (lpAddress: string, targetToken: string, prices: any) => {
  const web3 = new Web3(httpProvider)
  const lpAbi = (pancakeLpABI as unknown) as AbiItem
  const bep20TokenAbi = (bep20 as unknown) as AbiItem
  const contract = new web3.eth.Contract(lpAbi, lpAddress)
  const token0 = await contract.methods.token0().call()
  const token1 = await contract.methods.token1().call()

  if (token0?.toLowerCase() === targetToken?.toLowerCase()) {
    const token0Contract = new web3.eth.Contract(bep20TokenAbi, token0)
    const token1Contract = new web3.eth.Contract(bep20TokenAbi, token1)
    const token0Balance = await token0Contract.methods.balanceOf(lpAddress).call()
    const token1Balance = await token1Contract.methods.balanceOf(lpAddress).call()
    const token1Price = new BigNumber(prices[token1]?.price || 0)

    return token1Price.times(token1Balance).div(token0Balance).toNumber()
  }

  if (token1?.toLowerCase() === targetToken?.toLowerCase()) {
    const token0Contract = new web3.eth.Contract(bep20TokenAbi, token0)
    const token1Contract = new web3.eth.Contract(bep20TokenAbi, token1)
    const token0Balance = await token0Contract.methods.balanceOf(lpAddress).call()
    const token1Balance = await token1Contract.methods.balanceOf(lpAddress).call()
    const token0Price = new BigNumber(prices[token0]?.price || 0)

    return token0Price.times(token0Balance).div(token1Balance).toNumber()
  }

  return 0
}
